
interface IConfig {
    attributeNames: string[],
    organizationName: string,
    organizationId: number
}

export const config: IConfig = {
    attributeNames: ["CCPCoverageArea"],
    organizationName: "ChildOrg",
    organizationId: 123
}

